/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { getMembershipHistories, getMemberships } from '../../apis/membership';
import { getParams } from '../../utils/params';
import Filters from '../Filters';
import { ControlTable } from '../Table';
import { MEMBERSHIP_TARGET_TYPE } from '../../constants/MEMBERSHIP';
import { isEmpty } from '../../utils/lodashExtend';
import MembershipHistory from './MembershipHistory';

const MembershipHistories = () => {
  const [fields] = useState([
    { title: "관리회사", key: "managerCompany.name" },
    { title: "경리지원회사", key: "company.name" },
    { title: "멤버십 등급", key: "membership.label" },
    { title: "멤버십 대상", key: "membership.targetType", onValue: (v) => MEMBERSHIP_TARGET_TYPE.find(f => f.value === v)?.label },
    { title: "멤버십 사용여부", key: "membership.isEnable", onValue: (v) => v ? <span className="color-main-100">사용</span> : <span className="error">중지</span> },
    { title: "작성자", key: "employee", onValue: (v) => v.company.type === 9 ? "wecake" : v.name },
    { title: "작성일", key: "cratedTime", type: "date" },
  ]);
  const [filters, setFilters] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [membershipList, setMembershipList] = useState(false);
  const [companyIdx, setCompanyIdx] = useState(null);

  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit
  } = useForm({
    limit: 10,
    offset: 0,
    search: {
      level: "all",
      targetType: "all",
    }
  });

  const submit = (form) => {

    if (form.search?.level === "all") delete form.search.level;
    if (form.search?.targetType === "all") delete form.search.targetType;
    setIsLoading(true);
    getMembershipHistories(getParams(form))
      .then(res => {
        const { rows = [], count = 0 } = res;
        setTotal(count);
        setList(rows);
      }).finally(() => setIsLoading(false));
  };


  useEffect(() => {
    getMemberships({}).then(res => {
      setMembershipList(res.rows.map(item => ({ ...item, value: item.level })));
      submit(form);
      setSubmit(submit);
    });
  }, []);

  useEffect(() => {
    if (!isEmpty(membershipList)) {
      setFilters([
        {
          title: "경리지원회사 검색",
          type: "input",
          placeholder: "경리지원 회사명 입력",
          key: "search.companyName",
        },
        {
          title: "관리회사 검색",
          type: "input",
          placeholder: "관리 회사명 입력",
          key: "search.managerComName",
        },
        {
          title: "대상",
          type: "select",
          options: {
            list: [{ label: "전체", value: "all" }, ...MEMBERSHIP_TARGET_TYPE]
          },
          key: "search.targetType",
        },
        {
          title: "멤버십 등급",
          type: "select",
          options: {
            list: [{ label: "전체", value: "all" }, ...membershipList]
          },
          key: "search.level",
        }
      ]);

    }
  }, [membershipList]);


  const handleOnSelect = (d) => {
    setCompanyIdx(d?.company?.idx);
    setDetailOpen(true);
  };

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideControlHeader
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={false}
        selectedList={selectedList}
        setSelected={setSelectedList}
        onSelect={handleOnSelect}
      />

      <MembershipHistory
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
        companyIdx={companyIdx}
      />
    </>
  );
};

export default MembershipHistories;